import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Get } from '../../utils/httpProvider';
import { NHAN_VIEN_API } from '../../utils/apiUrl.js';

export const getHoSoCVAction = createAsyncThunk(
    'scienceProfile/getHoSoCV',
    async (id) => {
        return Get(NHAN_VIEN_API.GET_HOSO_CV, id, null)
            .then((response) => response)
            .catch((error) => error);
    }
);

export const getNhanVienByIdAction = createAsyncThunk(
    'scienceProfile/getNhanVienById',
    async (id) => {
        return Get(NHAN_VIEN_API.GET_BY_ID, id, null)
            .then((response) => response)
            .catch((error) => error);
    }
);

const initialState = {
    hoSoCV: null,
    loadingCV: false,
    nhanVien: null,
    loadingNhanVien: false,
};

export const scienceProfileSlice = createSlice({
    name: 'scienceProfile',
    initialState,
    reducers: {
        clearScienceProfileState: (state) => {
            state.hoSoCV = null;
            state.nhanVien = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // getHoSoCVAction
            .addCase(getHoSoCVAction.pending, (state) => {
                state.loadingCV = true;
            })
            .addCase(getHoSoCVAction.fulfilled, (state, action) => {
                state.loadingCV = false;
                if (action.payload && !action.payload.error) {
                    state.hoSoCV = action.payload;
                }
            })
            .addCase(getHoSoCVAction.rejected, (state) => {
                state.loadingCV = false;
                state.hoSoCV = null;
            })
            // getNhanVienByIdAction
            .addCase(getNhanVienByIdAction.pending, (state) => {
                state.loadingNhanVien = true;
            })
            .addCase(getNhanVienByIdAction.fulfilled, (state, action) => {
                state.loadingNhanVien = false;
                if (action.payload && !action.payload.error) {
                    state.nhanVien = action.payload;
                }
            })
            .addCase(getNhanVienByIdAction.rejected, (state) => {
                state.loadingNhanVien = false;
                state.nhanVien = null;
            });
    }
});

export const { clearScienceProfileState } = scienceProfileSlice.actions;

export default scienceProfileSlice.reducer;
